import GooglePlacesShadowStyler from "./addressAutocompleteShadowRoot";
class AddressAutocomplete {
  constructor(options = {}) {
    this.options = {
      inputWrapperSelector: '[data-input-wrapper="checkout-address"]',
      fields: ["formattedAddress", "location"],
      autofillPostcodeAndCity: true,
      ...options
    };
    this.country_code = Theme.settings.country_iso_code;
    this.autocompleteEl = null;
    this.addressInput = document.querySelector('input[name="checkout-address"]');
    this.widgetEl = document.querySelector('gmp-place-autocomplete');
    if(this.widgetEl){
      this.widgetWrapperEl = this.widgetEl.closest('[data-input-wrapper="checkout-address"]');
    }
    this.place = null;
    GooglePlacesShadowStyler();
    this.init();
  }

  async init() {
    await this.initializeAutocomplete();
    if (this.autocompleteEl !== null && this.addressInput ) {
      this.addressInput.classList.add('d-none');
      this.styleAutocomplete();
      this.autoCompleteInput = this.autocompleteEl.shadowRoot.querySelector('input');
      this.syncInputValues();
    }
  }


  
  syncInputValues() {
    if (this.addressInput && this.autoCompleteInput) {
      this.autoCompleteInput.addEventListener('change', () => {
        this.addressInput.value = this.autoCompleteInput.value;
        this.addressInput.dispatchEvent(new Event('auto-complete-input:changed', { bubbles: true }));
      });
      this.autoCompleteInput.addEventListener('focus', () => {
        this.addressInput.classList.add('forced-focus');
        this.autoCompleteInput.classList.add('forced-focus');
      });

      this.autoCompleteInput.addEventListener('blur', (event) => {
        if(event.target.value.length > 0) {
          this.addressInput.classList.add('forced-focus');
          this.autoCompleteInput.classList.add('forced-focus');
        }
        else {
          this.addressInput.classList.remove('forced-focus');
          this.autoCompleteInput.classList.remove('forced-focus');
        }
      });
    }
  }

  async initializeAutocomplete() {
    try {
      await google.maps.importLibrary("places");
      this.autocompleteEl = new google.maps.places.PlaceAutocompleteElement({
        includedRegionCodes: [this.country_code]
      });
      this.setupAutocomplete();
    } catch (error) {
      console.error('Error initializing address autocomplete:', error);
    }
  }

  styleAutocomplete() {
    this.autocompleteEl.classList.add('address-autocomplete');

  }
  setupAutocomplete() {
    const wrapper = document.querySelector(this.options.inputWrapperSelector);
    if (!wrapper) {
      console.error('Address input wrapper not found');
      return;
    }
    
    wrapper.prepend(this.autocompleteEl);
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.autocompleteEl.addEventListener("gmp-select", this.onPlaceSelected.bind(this));
  }

  async onPlaceSelected(event) {
    try {
      this.place = event.placePrediction.toPlace();
      await this.place.fetchFields({
          fields: ['addressComponents', 'formattedAddress', 'location'], // <- important
      });
      const components = this.place.addressComponents;
      const getComponent = (type) =>
      components.find((comp) => comp.types.includes(type))?.longText || '';
      
      const street = getComponent("route");
      const streetNumber = getComponent("street_number");
      const postalCode = getComponent("postal_code");
      const city = getComponent("locality") || getComponent("postal_town");

      const fullAddress = {
        street,
        streetNumber,
        postalCode,
        city
      }
      
      this.handlePlaceSelected(fullAddress);
    } catch (error) {
      console.error('Error processing selected place:', error);
    }
  }


  handlePlaceSelected(place) {
    const event = new CustomEvent('address:autocomplete', { 
      detail: { place: place } 
    });
    document.dispatchEvent(event);
  }

  /**
   * Clean up event listeners and elements
   */
  destroy() {
    if (this.autocompleteEl) {
      this.autocompleteEl.removeEventListener('gmp-select', this.onPlaceSelected);
      this.autocompleteEl.remove();
    }
  }
}
export default AddressAutocomplete;